export default "__VITE_PUBLIC_ASSET__ac8ffc1e__"